import React from "react";
import { Div, Image, Row, Col, Text } from "atomize";
import velo from "../../assets/images/velo.png";

const OtherEBikes = () => {
  return (
    <div className="container">
      <Text textSize="display1">Other Type Of Bikes</Text>
      <Row m={{ y: "3rem" }}>
        <Col>
          <Div
            textAlign="center"
            bg="#FFFFFFF"
            shadow="4"
            p={{ y: "0.5rem", x: "2rem" }}
            rounded="10px"
            border="2px solid"
            borderColor="#ffbd37"
          >
            <Image src={velo} alt="ebike" w="120px" h="80px" />
          </Div>
          <Div textColor="#ffbd37" textAlign="center" m={{ t: "1rem" }}>
            Hybrid Bikes
          </Div>
        </Col>
        <Col>
          <Div
            textAlign="center"
            bg="#FFFFFFF"
            shadow="4"
            p={{ y: "0.5rem", x: "2rem" }}
            rounded="10px"
          >
            <Image src={velo} alt="ebike" w="120px" h="80px" />
          </Div>
          <Div textAlign="center" m={{ t: "1rem" }}>
            Fixie Bikes
          </Div>
        </Col>
        <Col>
          <Div
            textAlign="center"
            bg="#FFFFFFF"
            shadow="4"
            p={{ y: "0.5rem", x: "2rem" }}
            rounded="10px"
          >
            <Image src={velo} alt="ebike" w="120px" h="80px" />
          </Div>
          <Div textAlign="center" m={{ t: "1rem" }}>
            Folding Bikes
          </Div>
        </Col>
        <Col>
          <Div
            textAlign="center"
            bg="#FFFFFFF"
            shadow="4"
            p={{ y: "0.5rem", x: "2rem" }}
            rounded="10px"
          >
            <Image src={velo} alt="ebike" w="120px" h="80px" />
          </Div>
          <Div textAlign="center" m={{ t: "1rem" }}>
            Mount Bikes
          </Div>
        </Col>
        <Col>
          <Div
            textAlign="center"
            bg="#FFFFFFF"
            shadow="4"
            p={{ y: "0.5rem", x: "2rem" }}
            rounded="10px"
            style={{ opacity: "0.5" }}
          >
            <Image src={velo} alt="ebike" w="120px" h="80px" />
          </Div>
          <Div textAlign="center" m={{ t: "1rem" }}>
            City Bikes
          </Div>
        </Col>
      </Row>
    </div>
  );
};

export default OtherEBikes;
